import styled from "styled-components";

export const GlobalSkills = styled.div`
  height: 600px;

  @media (max-width: 768px) {
    height: 650px;
  }
  @media (max-width: 415px) {
    height: 650px;
  }
  @media (max-width: 376px) {
    height: 670px;
  }
`;
